import { render, staticRenderFns } from "./viewDetail.vue?vue&type=template&id=e9b07f74&scoped=true"
import script from "./viewDetail.vue?vue&type=script&lang=js"
export * from "./viewDetail.vue?vue&type=script&lang=js"
import style0 from "./viewDetail.vue?vue&type=style&index=0&id=e9b07f74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b07f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9b07f74')) {
      api.createRecord('e9b07f74', component.options)
    } else {
      api.reload('e9b07f74', component.options)
    }
    module.hot.accept("./viewDetail.vue?vue&type=template&id=e9b07f74&scoped=true", function () {
      api.rerender('e9b07f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/temporaryWorkerAccount/cmp/viewDetail.vue"
export default component.exports